import { getResourceErrorMeta } from '../../../client/errorMeta';
export class RpcError extends Error {
  constructor(rpcError, callSiteStack) {
    super('CHIRP RPC failed');
    this.name = 'RpcError';
    this.rpcError = rpcError;
    if (callSiteStack) {
      this.stack = callSiteStack;
    }
  }
}
export const isRpcError = (resource, error) => {
  if (!(error instanceof RpcError)) {
    return false;
  }
  const meta = getResourceErrorMeta(error);
  return !!meta && meta.typeName === resource.typeName;
};